import type {
  TvChannelUrlLibraryParams,
  TvChannelUrlSpecialParams,
} from '~/entities/redirect-url'
import type { AnalyticsQueryParams } from '~/shared/analytix'
import type { TvChannelPayment } from '../../interfaces'

import { createEvent, sample } from 'effector'
import { model as redirectUrlModel } from '~/entities/redirect-url'
import { isPaid } from '../../lib'
import { formatChannelExternalPayment } from '../../lib/channels'
import * as external from '../model'

export const selectTvChannel = createEvent<
  TvChannelPayment &
    TvChannelUrlLibraryParams &
    TvChannelUrlSpecialParams &
    AnalyticsQueryParams
>()

export const selectTvChannelOnEpg = createEvent<TvChannelPayment>()

export const payForTvChannel = createEvent<TvChannelPayment>()

export const payForTvBundle = createEvent<TvChannelPayment>()

sample({
  clock: selectTvChannel,
  fn: (selectTvChannelParams) => ({
    ...selectTvChannelParams,
    categoryId: selectTvChannelParams.categoryId ?? 0,
    categoryName: selectTvChannelParams.categoryName ?? '',
    routeName: selectTvChannelParams.routeName ?? '',
  }),
  target: redirectUrlModel.saveTvChannelRedirectUrl,
})

sample({
  clock: selectTvChannel,
  filter: ({ free, purchaseInfo }) => Boolean(free) || Boolean(purchaseInfo), // free content or already paid
  fn: (selectTvChannel) => selectTvChannel?.categoryName,
  target: redirectUrlModel.redirectToTvPlayer,
})

sample({
  clock: selectTvChannel,
  source: external.$externalPaymentEnabled,
  filter: (external, channel) => external && isPaid(channel),
  fn: (_, channel) => formatChannelExternalPayment({ channel }),
  target: external.selectForExternalPayment,
})

sample({
  clock: selectTvChannelOnEpg,
  source: external.$externalPaymentEnabled,
  filter: (external, channel) => external && isPaid(channel),
  fn: (_, channel) =>
    formatChannelExternalPayment({ channel, shouldRefresh: true }),
  target: external.selectForExternalPayment,
})
